import { FunctionFieldProps, FunctionField as RaFunctionField } from 'react-admin';

function FunctionField({ variant = 'body1', ...props }: FunctionFieldProps): JSX.Element {
  return <RaFunctionField {...props} variant={variant} />;
}

export { FunctionField };
export type { FunctionFieldProps };
